import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import VeteransBenefitsClaimsDetails from '../../subdepartmentdetails/VeteransBenefitsClaims'


function VeteransBenefitsClaims() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Veterans' Benefits and Claims Assistance || Veterans Affairs";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Veterans Affairs"
            title="Veterans Benefits Claims"
            subtitledown="Department of Veterans Affairs"
           />
            <VeteransBenefitsClaimsDetails/>
        </div>
    </>
  )
}

export default VeteransBenefitsClaims